import React from "react";
import { Button, TableCellLayout } from "@fluentui/react-components";
import { EditRegular, EyeFilled } from "@fluentui/react-icons";
import { ProspectionRecord } from "../index.types";
import { useGetBasicCnpjInfo } from "hooks/Prospection/useProspectionSearch";
import { ProgressToast, SuccessToast } from "Components/MessageBars/toasts";
import { useAppToast } from "hooks/Toast/useAppToast";

export type TableRowActionsProps = {
  setSelectProspect: (company: ProspectionRecord) => void;
  setIsDrawerOpenTrue: () => void;
  record: ProspectionRecord;
};
export const TableRowActions = ({
  record,
  setIsDrawerOpenTrue,
  setSelectProspect,
}: TableRowActionsProps) => {
  const {
    useToastController: { dispatchToast, updateToast },
    toastId,
  } = useAppToast();

  const { data, refetch, isFetched } = useGetBasicCnpjInfo(record.cnpj);

  if (isFetched) {
    updateToast({
      toastId,
      timeout: 5000,
      intent: "success",
      content: (
        <SuccessToast
          subtitle={`Documento numero ${record.cnpj}`}
          message="Atualizacao concluida."
        />
      ),
    });
  }

  const onUpdate = () => {
    refetch();
    const toast = dispatchToast(
      <ProgressToast
        message="Atualizando..."
        body="Aguarde um momento..."
        subtitle={`Documento numero ${record.cnpj}`}
      />,
      {
        timeout: -1,
        toastId,
      },
    );
  };
  return (
    <TableCellLayout style={{ justifySelf: "end" }}>
      <Button
        icon={<EyeFilled />}
        appearance="primary"
        onClick={() => {
          setSelectProspect(record);
          setIsDrawerOpenTrue();
        }}
        style={{ marginRight: "8px" }}
      >
        View
      </Button>
      <Button
        icon={<EditRegular />}
        appearance="outline"
        onClick={() => onUpdate()}
      >
        Update
      </Button>
    </TableCellLayout>
  );
};
